<!--
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-24 17:41:16
 * @Description:
-->
<template>
  <div class="student-rights">
    <a-button v-if="activeKey !== '3'" type="link" class="sel-log-btn" @click="selectLog">
      查询权益有效期 >>
    </a-button>
    <a-tabs @change="tabChange" :active-key="activeKey">
      <a-tab-pane key="1" tab="课程权益消耗审核" />
      <a-tab-pane key="2" tab="小初全科/体验权益分配" />
      <a-tab-pane key="3" tab="次卡权益分配管理" />
    </a-tabs>
    <div class="right-wrap">
      <RightConsume v-if="activeKey === '1'" />
      <GiveRight v-if="activeKey === '2'" />
      <RightCiCard v-if="activeKey === '3'" />
    </div>
  </div>
</template>

<script>
import RightConsume from './rightConsume/index'
import GiveRight from './giveRight/index'
import RightCiCard from './rightCiCard/index'

export default {
  components: {
    GiveRight,
    RightConsume,
    RightCiCard
  },
  data() {
    return {
      activeKey: sessionStorage.getItem('tab1') || '2'
    }
  },

  methods: {
    selectLog() {
      this.$router.push({ name: 'rightLog' })
      // const num = this.activeKey === '1' ? 1 : 0
    },
    tabChange(v) {
      this.activeKey = v
      sessionStorage.setItem('tab1', this.activeKey)
    }
  }
}
</script>

<style scoped lang="less">
:deep(.ant-tabs-nav) {
  font-size: 18px !important;
}
.student-rights {
  height: 100%;
  padding: 24px;
  overflow: hidden;
  background: #fff;
  position: relative;
  .sel-log-btn {
    background: none;
    border: none;
    position: absolute;
    right: 12px;
    top: 28px;
    z-index: 1;
  }
  .ant-tabs-line {
    padding-left: 0;
    box-shadow: 0px 1px 0px #EBEDF0;
    height: 39px;
  }
  :deep(.ant-tabs-ink-bar) {
    position: absolute;
    left: 13%;
  }
  .right-wrap {
    height: 100%;
    padding-top: 24px;
  }
}
</style>
